/** GZIP client-side per documenti — CompressionStream nativo con fallback fflate. */
import { gzipSync, gunzipSync } from 'fflate'

export function gzipSupported(): boolean {
  return typeof CompressionStream !== 'undefined' && typeof DecompressionStream !== 'undefined'
}

async function streamToBytes(stream: ReadableStream<Uint8Array>): Promise<Uint8Array> {
  const buf = await new Response(stream).arrayBuffer()
  return new Uint8Array(buf)
}

export async function gzipCompress(data: Uint8Array): Promise<Uint8Array> {
  if (gzipSupported()) {
    const input = new Blob([new Uint8Array(data)])
    const compressed = input.stream().pipeThrough(new CompressionStream('gzip'))
    return streamToBytes(compressed)
  }
  return gzipSync(data)
}

export async function gzipDecompress(data: Uint8Array): Promise<Uint8Array> {
  if (gzipSupported()) {
    const input = new Blob([new Uint8Array(data)])
    const decompressed = input.stream().pipeThrough(new DecompressionStream('gzip'))
    return streamToBytes(decompressed)
  }
  return gunzipSync(data)
}

/** Comprime solo se riduce la dimensione; altrimenti pass-through. */
export async function gzipCompressIfSmaller(
  data: Uint8Array,
): Promise<{ bytes: Uint8Array; gzipped: boolean }> {
  if (data.length < 256) {
    return { bytes: data, gzipped: false }
  }
  const compressed = await gzipCompress(data)
  if (compressed.length >= data.length) {
    return { bytes: data, gzipped: false }
  }
  return { bytes: compressed, gzipped: true }
}
